<template>
  <div class="d-flex flex-grow-1 h-0 flex-column">
    <FdScroll x y>
      <router-view/>
    </FdScroll>
  </div>
</template>

<script>
import FdScroll from "@/flexdesign/Scroll";

export default {
  name: "GmbApp",

  components: {
    FdScroll,
  },

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/main";
</style>
